import { render, staticRenderFns } from "./mark-edit.vue?vue&type=template&id=0e5df940&"
import script from "./mark-edit.vue?vue&type=script&lang=js&"
export * from "./mark-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports